module.exports = __webpack_public_path__ + "img/sctr2.8609bdda.png";